import { Stack, Checkbox, Typography } from "@mui/material";
import moment from "moment";
// Custom hook
import useCheckStudentAttendance from "../../../Hooks/useCheckStudentAttendance";

const attendanceOptions = [
  { key: "present", label: "C", color: "green" },
  { key: "late", label: "L", color: "orange" },
  { key: "permission", label: "P", color: "blue" },
  { key: "absent", label: "A", color: "red" },
];

export default function CheckAttendance({
  date,
  classId,
  editData,
  setRefetch,
}) {
  const { handleSubmit } = useCheckStudentAttendance({
    setRefetch,
    date: moment(date).format("YYYY-MM-DD"),
    classId,
    studentId: editData?._id,
  });

  const handleChange = (statusKey) => {
    const currentStatus = editData?.status;
    const newStatus = currentStatus === statusKey ? "empty" : statusKey;
    handleSubmit(newStatus, editData?.reason);
  };

  return (
    <Stack
      direction="row"
      spacing={4}
      justifyContent="center"
      alignItems="center"
    >
      {attendanceOptions?.map(({ key, label, color }) => (
        <Stack key={key} direction="row" alignItems="center">
          <Checkbox
            checked={editData?.status === key}
            sx={{ color: `${color} !important` }}
            onChange={() => handleChange(key)}
          />
          <Typography>{label}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
